import React, { useEffect, useState } from 'react'

const useOverflowCheck = (ref: React.RefObject<HTMLDivElement>) => {
  const [isOverflowing, setIsOverflowing] = useState<boolean>(false)

  useEffect(() => {
    const checkOverflow = () => {
      if (ref.current) {
        const { clientWidth, scrollWidth } = ref.current
        setIsOverflowing(scrollWidth > clientWidth)
      }
    }

    checkOverflow()

    const handleResize = () => {
      checkOverflow()
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [ref])

  return isOverflowing
}

export default useOverflowCheck
